<template>
  <section class="why-choose-us py-16">
    <v-container>
      <v-row class="align-center">
        <!-- Left Column: Content -->
        <v-col cols="12" md="6" class="pr-md-8">
          <v-chip
            color="primary"
            variant="flat"
            size="small"
            class="font-weight-bold mb-3 px-4"
          >
            FIRMA INMOBILIARIA CONSOLIDADA
          </v-chip>

          <h2 class="section-title mb-6">
            ¿Por Qué Elegir a <span class="text-primary">León & Casallas</span>?
          </h2>

          <p class="section-subtitle text-grey-darken-1 mb-8">
            En un mercado inmobiliario exigente en el norte de Cundinamarca, usted necesita una firma con sólida trayectoria que combine el conocimiento predial, marketing moderno y el respaldo jurídico necesario para vender o arrendar su propiedad en tiempo récord y con total seguridad.
          </p>

          <div class="features-list">
            <div
              v-for="(item, index) in reasons"
              :key="index"
              class="feature-item d-flex align-start mb-6"
            >
              <div class="feature-icon-wrapper mr-4 flex-shrink-0">
                <v-icon color="white" size="24">{{ item.icon }}</v-icon>
              </div>
              <div>
                <h4 class="text-h6 font-weight-bold mb-1 text-grey-darken-4">
                  {{ item.title }}
                </h4>
                <p class="text-body-2 text-grey-darken-2 mb-0">
                  {{ item.description }}
                </p>
              </div>
            </div>
          </div>
        </v-col>

        <!-- Right Column: Visual Highlights Card -->
        <v-col cols="12" md="6" class="mt-8 mt-md-0">
          <div class="highlight-wrapper pa-6 pa-md-10">
            <!-- Decorative circle -->
            <div class="glow-circle"></div>

            <div class="position-relative z-index-2">
              <div class="d-flex align-center mb-6">
                <v-icon color="white" size="32" class="mr-3">mdi-home-analytics</v-icon>
                <h3 class="text-h5 font-weight-bold text-white mb-0">
                  Respaldo Inmobiliario en todo el norte de Cundinamarca
                </h3>
              </div>

              <p class="text-body-1 text-grey-lighten-2 mb-8 line-height-relaxed">
                Nuestra consolidación en el norte de Cundinamarca nos permite valorar su predio con exactitud, conectarlo con el público objetivo adecuado y garantizar seguridad absoluta en cada contrato de venta o arriendo.
              </p>

              <!-- Stats check list -->
              <v-row class="mb-6">
                <v-col cols="6" class="d-flex align-center">
                  <v-icon color="white" class="mr-2">mdi-check-decagram</v-icon>
                  <span class="text-body-2 font-weight-medium text-white">Estudio de títulos incluido</span>
                </v-col>
                <v-col cols="6" class="d-flex align-center">
                  <v-icon color="white" class="mr-2">mdi-check-decagram</v-icon>
                  <span class="text-body-2 font-weight-medium text-white">Promoción multicanal</span>
                </v-col>
                <v-col cols="6" class="d-flex align-center">
                  <v-icon color="white" class="mr-2">mdi-check-decagram</v-icon>
                  <span class="text-body-2 font-weight-medium text-white">Trámites notariales ágiles</span>
                </v-col>
                <v-col cols="6" class="d-flex align-center">
                  <v-icon color="white" class="mr-2">mdi-check-decagram</v-icon>
                  <span class="text-body-2 font-weight-medium text-white">17+ Años de confianza</span>
                </v-col>
              </v-row>

              <!-- Experience Quote card -->
              <div class="quote-card pa-5">
                <div class="d-flex align-start">
                  <v-icon color="primary" size="36" class="mr-3">mdi-format-quote-open</v-icon>
                  <div>
                    <p class="text-body-2 text-grey-darken-3 font-italic mb-2">
                      "Nuestro compromiso es cuidar cada inversión como propia, asegurando que cada venta o arriendo se realice con rigor ético y tranquilidad para ambas partes."
                    </p>
                    <div class="text-caption font-weight-bold text-primary">
                      Equipo Consultor • León & Casallas
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'WhyChooseUs',
  data() {
    return {
      reasons: [
        {
          icon: 'mdi-shield-check',
          title: 'Estudio Técnico y Seguridad Predial',
          description:
            'Verificamos el historial de títulos y solvencia de los interesados antes de cerrar cualquier trato, protegiendo 100% su patrimonio.',
        },
        {
          icon: 'mdi-map-marker-radius',
          title: 'Conocimiento Sólido en el norte de Cundinamarca',
          description:
            'Más de 17 años operando de forma continua en Gachancipá, Sopó, Zipaquirá, Tocancipá, Suesca, Sesquilé y Guatavita.',
        },
        {
          icon: 'mdi-rocket-launch',
          title: 'Promoción Estratégica & Cierre Ágil',
          description:
            'Aplicamos mercadeo moderno, fotografía profesional y difusión en las mejores plataformas inmobiliarias para reducir el tiempo de venta o arriendo.',
        },
      ],
    };
  },
};
</script>

<style scoped>
.why-choose-us {
  background-color: #ffffff;
}

.section-title {
  font-size: clamp(1.8rem, 3.5vw, 2.6rem);
  font-weight: 900;
  line-height: 1.2;
  color: #1a1a1a;
}

.section-subtitle {
  font-size: 1.1rem;
  line-height: 1.6;
}

.feature-icon-wrapper {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: #A90707;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 16px rgba(169, 7, 7, 0.35);
}

.highlight-wrapper {
  background: radial-gradient(circle at 10% 20%, #2a2022 0%, #151518 100%);
  border-radius: 24px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.glow-circle {
  position: absolute;
  top: -50px;
  right: -50px;
  width: 260px;
  height: 260px;
  border-radius: 50%;
  background: rgba(169, 7, 7, 0.4);
  filter: blur(80px);
  z-index: 1;
}

.quote-card {
  background: rgba(255, 255, 255, 0.94);
  border-radius: 16px;
  border-left: 4px solid #A90707;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

.line-height-relaxed {
  line-height: 1.7;
}
</style>
